import apiSDO from '@/api/sdo';
import apiOption from '@/api/option';

const defaultState = () => ({
	listSDO: [],
	detailSDO: {},
	listSOProccess: [],
	sdoPagination: {},
	SDOStatus: [],
	warehouseResults: [],
	response: {
		code: '',
		message: ''
	},
	alertMultiple: [],
	responseError: {},
	OptionFreeTools: [],
	alert: ''
});

const state = defaultState();

const getters = {

};

const mutations = {
	setSDO(state, data) {
		state.listSDO = data.data
		state.sdoPagination = data.pagination;
	},
	setDetailSDO(state, data) {
		state.detailSDO = data
	},
	setSOProcess(state, data) {
		state.listSOProccess = data.data
	},
	listOptionStatus(state, data) {
		state.SDOStatus = [];
		state.SDOStatus = data;
	},
	setWarehouse(state, data) {
		state.warehouseResults = data
	},
	validationError(state, data) {
		state.responseError = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = []
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataSDO(state) {
		Object.assign(state, defaultState())
	},
	setOptionFreeTools (state, data) {
		state.OptionFreeTools = data
	},
};

const actions = {
	getSDO({ dispatch, commit }, params) {
		return new Promise((resolve) => {
			apiSDO.getSDO(params).then(({ data: { data } }) => {
				commit('setSDO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	getSDOAll({ dispatch, commit }, params) {
		return new Promise((resolve) => {
			apiSDO.getSDOAll(params).then(({ data: { data } }) => {
				commit('setSDO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	getDetailSDO({ commit, dispatch }, params) {
		apiSDO.getDetailSDO(params).then(({ data: { data } }) => {
			commit('setDetailSDO', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailSDO', { data: [] });
		});
	},
	getWarehouseOption({ commit }, params){
		return new Promise((resolve) => {
			apiOption.getOptionWarehouseAll(params).then(({ data: { data } }) => {
				commit('setWarehouse', data.results);
				resolve()
			}).catch(() => {
				commit('setWarehouse', []);
			});
		});
	},
	getSDOStatus({ dispatch, commit }) {
		return new Promise((resolve) => {
			apiSDO.getSDOStatus().then(({ data: { data: { results } } }) => {
				commit('listOptionStatus', results);
				resolve()
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	getSOPaid({ dispatch, commit }) {
		apiSDO.getSOPaid().then(({ data: { data } }) => {
			if (data.results.length == 0) {
				commit('setSOProcess', { data: [] });
			} else {
				commit('setSOProcess', { data: data.results });
			}
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
	getSOApproved({ dispatch, commit }) {
		apiSDO.getSOApproved().then(({ data: { data } }) => {
			if (data.results.length == 0) {
				commit('setSOProcess', { data: [] });
			} else {
				commit('setSOProcess', { data: data.results });
			}
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
	async exportSDO({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSDO.exportSDO(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Sales Delivery Order'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportSDOAll({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSDO.exportSDOAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Sales Delivery Order Warehouse'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async createSDO({ commit, dispatch }, params) {
		await apiSDO.createSDO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	async deliverySDO({ commit, dispatch }, params) {
		await apiSDO.deliverySDO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	scanSerial({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiSDO.scanSerial({
				serial: params.serial,
				card_type: params.card_type,
				is_serial: params.type,
				arr_serial: params.arr_serial,
			}).then( ( { data : { data } } ) => {
				var serialSuccess = data.results.filter((el) => {
					return el.status == "available" && el.type == params.type
				})

				var serialFailed = data.results.filter((el) => {
					return el.status != "available" || el.type != params.type
				})
				var res = {
					success: serialSuccess.map((el) => {
						return el.serial
					}),
					failed : serialFailed.reduce((r, a) => {
						r[a.note] = [...r[a.note] || [], a.serial];
						return r;
					}, {})
				}
				if (serialSuccess.length > 0)
					resolve(res)
				else
					reject(res)
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
	getOptionFreeTools({ dispatch, commit }) {
		apiOption.getOptionFreeTools().then(({ data: { data: { results } } }) => {
			commit('setOptionFreeTools', results);
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
